{{text}} &nbsp;{{date}} hrs. <i class="fa fa-info-circle info" aria-hidden="true" *ngIf="icon"></i>